import React from "react";
import { Schema, SelectPicker } from "rsuite";
import Form from "rsuite/es/Form";

import FormHOC from "hoc/FilltersForm";
import CustomField from "components/Form/CustomField";
import Text from "components/Form/Text";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    number: StringType().maxLength(40, "The maximum is only 40 characters."),
});


const AccessListFiltersFilter = ({ onChange, defaultFilters, service, ...props }) => {
    const strPlaceholder = service ? "Origin/origin prefix/destination" : "Sender ID/destination";

    return (
        <>
            <Form
                model={filtersModel}
                layout="inline"
                onChange={onChange}
                formDefaultValue={defaultFilters}
            >
                {service ? <CustomField
                    style={{ width: 160 }}
                    name="antf_key"
                    className="tableFilters_field"
                    errorPlacement="topEnd"
                    accepter={SelectPicker}
                    data={props.numberTypeFamilyList}
                    placeholder="Service name"
                    valueKey="antf_key"
                    labelKey="family_name"
                    type="text"
                /> : <></>}
                <Text name="str" placeholder={strPlaceholder} style={{ display: "inline-block" }} />
            </Form>
        </>
    );
};

export default FormHOC(AccessListFiltersFilter, filtersModel, 800);
